import { jsx } from '@emotion/core';
var styles = {
  width: '130px'
};
var THEME = {
  light: 'black',
  dark: 'white'
};
export var TrustpilotLogo = function TrustpilotLogo(_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? 'light' : _b;
  return jsx("img", {
    css: styles,
    src: "//cdn.trustpilot.net/brand-assets/1.0.3/logo-" + THEME[theme] + ".svg"
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/TrustpilotLogo/index.js
// module id = 1218
// module chunks = 0